import {
  Box,
  Flex,
  Avatar,
  HStack,
  Link,
  Image as ChakraImage,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { NavLink } from "react-router-dom";

const Links = [
  { name: "My Profile", path: "/my-profile" },
  { name: "Services", path: "/services" },
  { name: "About Us", path: "/about-us" }
];

const Navigation = ({ children, to }) => (
  <NavLink to={to}>
    <Link
      px={2}
      py={1}
      rounded={"md"}
      _hover={{
        textDecoration: "none",
        bg: useColorModeValue("secondary", "gray.700"),
      }}
    >
      {children}
    </Link>
  </NavLink>
);

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bgColor = useColorModeValue("background", "gray.900");
  const textColor = useColorModeValue("text", "text");

  return (
    <>
      <Box bg={bgColor} px={4}>
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={"center"}>
            <Box color={textColor}>
            <ChakraImage src="/assets/glamflow-logo.svg" alt="Logo" boxSize="50px" />
            </Box>
            <HStack
              as={"nav"}
              spacing={4}
              display={{ base: "none", md: "flex" }}
            >
              {Links.map((link) => (
                <Navigation key={link.name} to={link.path}>
                  {link.name}
                </Navigation>
              ))}
            </HStack>
          </HStack>
          <Flex alignItems={"center"}>
            <Menu>
              <MenuButton
                as={Button}
                rounded={"full"}
                variant={"link"}
                cursor={"pointer"}
                minW={0}
              >
                <Avatar
                  size={"sm"}
                  src={
                    "https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9"
                  }
                />
              </MenuButton>
              <MenuList>
                <MenuItem>
                  <NavLink to='/appointments'>Appointments</NavLink>
                </MenuItem>
                <MenuItem>Link 2</MenuItem>
                <MenuDivider />
                <MenuItem>Logout</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              {Links.map((link) => (
                <Navigation key={link.name} to={link.path}>
                  {link.name}
                </Navigation>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}
